/**
 * 常量数据
 *
 * @description
 */

import { useI18n } from 'vue-i18n';

/**
 * 项目数据（前几期）
 *
 * @description 因业务紧急前端临时维护的数据。后续尽量让后端做兼容
 */
export const useProjects = () => {
    const { t } = useI18n();
    return {
        // 第一期
        20210922001: {
            desc: t('lp_item_desc'),
            currency: 'USD',
        },
        // 第二期
        202110281813: {
            desc: t('lpn_project_desc'),
            currency: 'BIT',
        },
        20211109194600: {
            desc: t('lp3_project_desc'),
            currency: 'BIT',
        },
        20211118141300: {
            desc: t('lp4_project_desc'),
            currency: 'BIT',
        },
        202111251726: {
            desc: t('lp5_project_desc'),
            currency: 'BIT',
        },
        202112021732: {
            desc: t('lp6_project_desc'),
            currency: 'BIT',
        },
        202112101700: {
            desc: t('lp7_project_desc'),
            currency: 'BIT',
        },
        202112281808: {
            desc: t('lp8_project_desc'),
            currency: 'BIT',
        },
        202201101600022: {
            desc: t('lp9_project_desc'),
            currency: 'BIT',
        },
        202202151600011: {
            desc: t('lp10_project_desc'),
            currency: 'BIT',
        },
    };
};

/**
 * 状态数据
 *
 * @description value：状态值  label：状态文案  tips：状态提示  color: 状态标签颜色
 */
export const useStatus = () => {
    const { t } = useI18n();
    return [
        {
            value: 1,
            label: t('lpn_active_status1'), // TODO 即将上线 => 预热期
            color: 'pick',
        },
        {
            value: 2,
            label: t('lpn_active_status2'),
            color: 'green',
        },
        {
            value: 3,
            label: t('lpn_active_status3'), // TODO 快照结算 => 统计计算中
            color: 'blue',
        },
        {
            value: 4,
            label: t('lpn_active_status4'),
            color: 'primary',
        },
        {
            value: 5,
        },
        {
            value: 6,
            label: t('lpn_active_status5'), // TODO 发放期 => 分配期
            color: 'orange',
        },
        {
            value: 7,
            label: t('lpn_active_status6'),
        },
    ];
};

/**
 * 整体导出
 */
export const useConstant = () => ({
    PROJECTS: useProjects(),
    STATUS: useStatus(),
});
